// Added by Team Twisty Sushma: loads <lazy-video> videos only when they scroll near the viewport,
// plays them once they are on screen, and pauses them again when they scroll out of view.
if (!customElements.get('lazy-video')) {
  customElements.define(
    'lazy-video',
    class LazyVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;

        if (!('IntersectionObserver' in window)) {
          this.loadVideo();
          this.playVideo();
          return;
        }

        // Start downloading a little before the video reaches the screen, so it is ready on arrival.
        this.loadObserver = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.loadObserver.disconnect();
            this.loadVideo();
          },
          { rootMargin: '0px 0px 200px 0px' }
        );
        this.loadObserver.observe(this.video);

        // Play only while at least a quarter of the video is visible; pause when it leaves the screen.
        this.playObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.loadVideo();
                this.playVideo();
              } else {
                this.video.pause();
              }
            });
          },
          { threshold: 0.25 }
        );
        this.playObserver.observe(this.video);
      }

      disconnectedCallback() {
        if (this.loadObserver) this.loadObserver.disconnect();
        if (this.playObserver) this.playObserver.disconnect();
      }

      loadVideo() {
        const isPhone = window.matchMedia('(max-width: 749px)').matches;
        const src = (isPhone && this.video.dataset.srcMobile) || this.video.dataset.src;
        if (!src || this.video.getAttribute('src')) return;

        this.video.src = src;
      }

      playVideo() {
        const playPromise = this.video.play();
        if (playPromise) playPromise.catch(() => {});
      }
    }
  );
}
